import order from './services/order'
import userInfo from './services/userInfo'
import wechatPay from './services/wechatPay'
import messageApi from './services/message'

const base = {
  proxyGet: '/proxy/get'
}

export {
  base,
  order,
  userInfo,
  wechatPay,
  messageApi
}




// WEBPACK FOOTER //
// ./src/apis/index.js